export default "__VITE_ASSET__BNHBJyGZ__"